import {
  ArrowRightOutlined,
  ReloadOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { Button, Card, Spin } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAsyncEffect } from "use-async-effect";
import reportService from "../../../services/report.service";
import "../home/home.scss";

interface Props {
  init: boolean;
}

const ShopRequestCount: React.FC<Props> = ({ init }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [shopRequestCount, setShopRequestCount] = useState<string>("");

  const getShopRequestCount = async () => {
    setLoading(true);
    const response = await reportService.getShopRequestCount();
    setShopRequestCount(response.shop_requests_count);
    setLoading(false);
  };

  useAsyncEffect(async () => {
    getShopRequestCount();
  }, []);

  return (
    <Card className="dashboard-card">
      <div className="widget-header">
        <span className="widget-title">Shop Requests</span>
        <div className="widget-actions">
          <Button
            onClick={getShopRequestCount}
            icon={<ReloadOutlined />}
            disabled={loading}
            size="small"
          />
          <Link to="/shop-requests">
            <Button icon={<ArrowRightOutlined />} size="small" />
          </Link>
        </div>
      </div>

      <div className="stat-card">
        {!loading ? (
          <>
            <ShopOutlined className="stat-icon" />
            <div className="stat-value">{shopRequestCount}</div>
          </>
        ) : (
          <Spin />
        )}
      </div>
    </Card>
  );
};

export default ShopRequestCount;
